import * as React from 'react';

import { 
    Box, 
    Typography, 
    CircularProgress,
    TextField,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Button
} from '@mui/material';

import { SimpleValidators, TS_CONSTS } from '../../../../utils';
import { Candid } from '../../../../controllers';
import { Confirmation } from '../../../utils';

export default function Main({handleChange}){

    const [data, setData] = React.useState([['','','']]);
    const [confirm, showConfirm] = React.useState(false);

    const indexes_names = {
        order: 0,
        dhr: 1,
        count: 2
    };

    const handleChangeDhr = async(e) => {
        var tmp = [];
        const side = indexes_names[e.target.name];
        const index = e.target.id;
        const value = side === 1 ? `${e.target.value}`.toUpperCase() : e.target.value;
        
        if(side === 1 && value.length > 5){
            return;
        }

        data.forEach(x => tmp.push(x));
        tmp[index][side] = value;

        const order = tmp[tmp.length - 1][0];
        const dhr = tmp[tmp.length - 1][1];
        const count = tmp[tmp.length - 1][2];

        if([order, dhr, count].every(Boolean)){
            tmp.push(['','']);
        }

        setData(tmp);
    }

    const Analisys = async() => {
        showConfirm(false);
        const uniques = await SimpleValidators.Uniques(data, 1);
        const valids = uniques.filter(x => x.length === 5);
        
        var indexes = [];
        var pass = [];

        valids.forEach( x => {
            let cycle = data.findIndex( y => y[1] === x);
            indexes.push(cycle);
        });

        for( let i = 0; i < indexes.length; i++){
            const job = data[indexes[i]];
            const order = job[0];
            const dhr = job[1];
            const counter = Number(job[2]);

            if(!counter > 0){
                continue;
            }

            const result = await handleCoProcessing(order, dhr, counter);

            if(result){
                pass.push(indexes[i]);
            }
        }

        const completed = data.filter((x,i) => pass.includes(i));
        const completedUniques = await SimpleValidators.Uniques(completed, 1);
        const remains = data.filter(x => !completedUniques.includes(x[1]));
        
        setData(remains);
        alert('Orders Processed. Ivalid-remaining inputs should be check and re-sent');
    }

    const handleCoProcessing = async(order, dhr, counter) =>{

        const payload = {
            order : dhr,
            data : {
                number: order,
                counter : {
                    dhr: counter,
                    counter: counter,
                },
                area : {
                    name : '3D',
                    id : 0,
                }
            }
        }

        const response = await Candid.CreateTracing(payload);

        if(response == undefined){
            alert(`Error Processing Order: ${order}. \nPlease, try again`);
            return false;
        }

        if(!response.success){
            alert(`Erro Processing Order: ${order}. \nPlease, try again`);
            return false;
        }

        return true;
    }

    return(
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                width:'100%',
            }}
        >
            <Confirmation 
                open={confirm}
                onClose={() => showConfirm(false)}
                onConfirm={Analisys}
                title={'Confirmation'}
                msg={'DHRs will be proccessed. Do you want to continue?'}
            />

            <Typography variant='h5'>Candid DHR</Typography>
            <Typography > Mass Input </Typography>
            <Divider sx={{minWidth:'100%'}}></Divider>

            <TableContainer sx={{mt:4, mb:2}}>
                <Table>
                     <TableBody>
                        
                        <TableRow
                            sx={{ borderBottom : 2, borderColor : 'gray'}}
                        >
                            <TableCell align='center'>
                                <Typography variant='h6'> Order ID</Typography>
                            </TableCell>

                            <TableCell 
                                align='center'
                                sx={{ border : 1, borderColor : 'lightgray', borderBlockStart: 0}}
                            >
                                <Typography variant='h6'> Case ID</Typography>
                            </TableCell>

                            <TableCell 
                                align='center'
                                sx={{ border : 1, borderColor : 'lightgray', borderBlockStart: 0}}
                            >
                                <Typography variant='h6'> Counter </Typography>
                                
                            </TableCell>
                        </TableRow>

                        {data != undefined && data.map( (x,i) => (
                            <TableRow
                                sx={{ borderBottom : 2, borderColor : 'lightgray'}}
                            >
                                <TableCell align='center'>
                                    <TextField 
                                        fullWidth
                                        value={x[0]}
                                        id={`${i}`}
                                        name='order'
                                        onChange={e => handleChangeDhr(e)}
                                        max
                                    />
                                </TableCell>
                                <TableCell 
                                    align='center'
                                    sx={{ border : 1, borderColor : 'lightgray', borderBlockStart: 0}}
                                >
                                    <TextField 
                                        fullWidth
                                        value={x[1]}
                                        id={`${i}`}
                                        name='dhr'
                                        onChange={e => handleChangeDhr(e)}
                                        max
                                    />
                                </TableCell>
                                <TableCell 
                                    align='center'
                                    sx={{ border : 1, borderColor : 'lightgray', borderBlockStart: 0}}
                                >
                                    <TextField 
                                        type='number'                                        
                                        fullWidth
                                        value={x[2]}
                                        id={`${i}`}
                                        name='count'
                                        onChange={e => handleChangeDhr(e)}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}

                    </TableBody>
                </Table>
            </TableContainer>

            <Button 
                variant='contained' 
                color='success'
                fullWidth
                onClick={() => showConfirm(true)}
            >
                Proccess DHRs
            </Button>
        </Box>
    );
}